import React, { useMemo } from 'react';
import './DesignerSubActions.less';
import { ActionLinks } from 'components/ActionLinks/ActionLinks';
import { IActionLinkItem } from 'components/ActionLinks/ActionLinkModels';

interface IDesignerSubActionsProps {
  subActions: IDesignerSubAction[];
  close: () => void;
}

export interface IDesignerSubAction {
  name: string;
  title?: string;
  action: () => void;
}

export function DesignerSubActions({ subActions, close }: IDesignerSubActionsProps) {
  const actions: IActionLinkItem[] = useMemo(() => {
    return subActions.map(action => {
      return {
        value: action.name,
        label: action.name,
        onClick: () => {
          action.action();
          close();
        },
      } as IActionLinkItem;
    });
  }, [close, subActions]);

  return (
    <ul className="dpc-designer-sub-actions">
      <ActionLinks values={{ current: actions }} />
    </ul>
  );
}
